import { doc, p, text, blockQuote, inlineCard } from '@atlaskit/adf-utils/builders';

const processTextToParagraphs = (input: string) => {
	return input.split('\n').map((section) => (!!section ? p(text(section)) : p()));
};

const convertUrlToInlineCardParagraph = (url: string) => {
	return !!url ? p(inlineCard({ url })) : p();
};

export const generateQuote = (input: string, pageUrl: string) => {
	return doc(
		blockQuote(...processTextToParagraphs(input), convertUrlToInlineCardParagraph(pageUrl)),
	);
};
